export const GLOBAL_STYLES = `
  :root {
    --acc: #00d4aa;
    --blue: #3b82f6;
    --err: #ef4444;
    --warn: #f59e0b;
    --ok: #10b981;

    --bg: #0a0e1a;
    --surf: #111827;
    --surf2: #1f2937;
    --brd: #374151;
    --txt: #e5e7eb;
    --muted: #9ca3af;
  }

  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    background: var(--bg);
    color: var(--txt);
    font-family: 'Sora', sans-serif;
  }
`;